<template>
    <div class="relative">
        <div class="absolute -mt-1 md:-mt-12 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-minus"></i>
        </div>

        <form-row title="Other Fees"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="flex flex-wrap flex-1 items-center -mt-6 md:mt-0">
                <div class="sm:w-36 my-2 md:mt-0 mr-6">
                    <input-money
                        name="list_side_other_fees"
                        label=" "
                        :value="value"
                        @input="$emit('input', $event)"
                        :read_only="read_only"
                    />
                </div>

                <div class="w-full sm:flex-1 my-2 md:mt-0">
                    <input-text
                        label="Description of Other Fees"
                        name="list_side_other_fees_description"
                        :value="commission_detail.list_side_other_fees_description"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
export default {
    props: {
        commission_detail: { default: () => ({}) },
        value: { default: null },
        read_only: { default: false },
    },
}
</script>
